import BtnSelect from "./Index.vue";
BtnSelect.install = function(Vue) {
  Vue.component(BtnSelect.name, BtnSelect);
};

export default BtnSelect;
